import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=7d6afdd9&scoped=true"
import script from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&id=7d6afdd9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6afdd9",
  null
  
)

export default component.exports